import { useEffect, useRef } from "react";
import { useSession } from "Contexts/SessionContext";
import { useFormData } from "Contexts/FormDataContext";
import { useProgress } from "Contexts/ProgressContext";
import { restoreFormDataFromSession } from "Lib/session-restore-utils";

export default function SessionFormDataSync({ children }) {
  const { sessionData, sessionCode } = useSession();
  const { restoreFromSession } = useFormData();
  const { restoreProgress } = useProgress();
  const hasRestored = useRef(false);

  useEffect(() => {
    if (sessionData && sessionCode && !hasRestored.current) {
      const restoredData = restoreFormDataFromSession(sessionData.responses);

      if (restoredData && Object.keys(restoredData).length > 0) {
        restoreFromSession(restoredData);
      }

      if (sessionData.current_page && sessionData.current_page > 1) {
        restoreProgress(sessionData.current_page);
      }

      hasRestored.current = true;
    }
  }, [sessionData, sessionCode, restoreFromSession, restoreProgress]);

  useEffect(() => {
    if (!sessionCode && hasRestored.current) {
      hasRestored.current = false;
    }
  }, [sessionCode]);

  return children;
}
